module.exports = __webpack_public_path__ + "img/dashboard-available.3d07f056.svg";